import { actionTypeKeys } from "../../external/actions/actionTypeKeys";
import { AnyAction } from "redux";
import { initialState } from "../../external/store/initialState";
import { Branch } from "../types/branch";

export default function branchesReducer(state: Branch[] = initialState.branches, action: AnyAction): Branch[] {
  switch (action.type) {
    case actionTypeKeys.LOAD_BRANCHES_SUCCESS:
      return [...action.branches];
    default:
      return state;
  }
}
